module.exports = new __parcel__URL__("nodejs.a3419a77.svg").toString();